export const CLEAR_ALL_DATA = 'CLEAR_ALL_DATA';
export const STORE_AUTH_DATA = 'STORE_AUTH_DATA';
